/* Do not change, this code is generated from Golang rpc-gen */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import objectHash from 'object-hash';
var cache = new Map();
export function retrieveCurrencies() {
    var _this = this;
    var value = cache.get('retrieveCurrencies');
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/currencies', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = 'retrieveCurrencies';
        cache.set(key, value);
        return value;
    });
}
export function retrieveSectors() {
    var _this = this;
    var value = cache.get('retrieveSectors');
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/sectors', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = 'retrieveSectors';
        cache.set(key, value);
        return value;
    });
}
export function retrieveSectorSelected() {
    var _this = this;
    return fetch('/exec-comp/api/sectorSelected', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); });
}
export function retrieveCountries(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCountries|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/countries', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCountries|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCountriesSelected() {
    var _this = this;
    return fetch('/exec-comp/api/countriesSelected', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); });
}
export function retrieveOnetJobGroups(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveOnetJobGroups|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/onetJobGroups', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveOnetJobGroups|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveOnetJobGroupsByCompanies(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveOnetJobGroupsByCompanies|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/onetJobGroupsByCompanies', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveOnetJobGroupsByCompanies|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveMinMaxJobClasses(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveMinMaxJobClasses|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/minMaxJobClasses', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveMinMaxJobClasses|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveJobClasses(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveJobClasses|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/jobClasses', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveJobClasses|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveJobClassesForCompanies(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveJobClassesForCompanies|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/jobClassesForCompanies', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveJobClassesForCompanies|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCompanyBenefits(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCompanyBenefits|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/companyBenefits', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCompanyBenefits|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCompanyBenefitsForCompanies(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCompanyBenefitsForCompanies|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/companyBenefitsForCompanies', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCompanyBenefitsForCompanies|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCompanyBenefitsByCompensation(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCompanyBenefitsByCompensation|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/companyBenefitsByCompensation', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCompanyBenefitsByCompensation|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCompanyBenefitsByTopN(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCompanyBenefitsByTopN|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/companyBenefitsByTopN', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCompanyBenefitsByTopN|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCompanies(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCompanies|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/companies', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCompanies|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveSalarySummary(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveSalarySummary|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/salarySummary', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveSalarySummary|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCompanyByNameCountryAndRevenue(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCompanyByNameCountryAndRevenue|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/companyByNameCountryAndRevenue', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCompanyByNameCountryAndRevenue|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveCompanyByName(data) {
    var _this = this;
    var hash;
    hash = objectHash(data);
    var value = cache.get("retrieveCompanyByName|" + hash);
    if (value) {
        return Promise.resolve(value);
    }
    return fetch('/exec-comp/api/companyByName', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); })
        .then(function (value) {
        var key = "retrieveCompanyByName|" + hash;
        cache.set(key, value);
        return value;
    });
}
export function retrieveAccessRights() {
    var _this = this;
    return fetch('/exec-comp/api/accessRights', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); });
}
export function retrieveExecCompUsers() {
    var _this = this;
    return fetch('/exec-comp/api/admin/execCompUsers', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); });
}
export function saveSectorSelected(data) {
    var _this = this;
    return fetch('/exec-comp/api/mutateSectorSelected', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); });
}
export function saveCountriesSelected(data) {
    var _this = this;
    return fetch('/exec-comp/api/mutateCountriesSelected', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); });
}
export function saveExecCompUser(data) {
    var _this = this;
    return fetch('/exec-comp/api/admin/saveExecCompUser', {
        method: 'POST',
        mode: 'same-origin',
        credentials: 'same-origin',
        headers: {
            'Content-Type': 'application/json',
        },
        redirect: 'follow',
        body: JSON.stringify(data),
    })
        .then(function (response) { return __awaiter(_this, void 0, void 0, function () {
        var src, errMsg;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (response.ok) {
                        return [2 /*return*/, response];
                    }
                    if (response.status === 401) {
                        src = window.location.pathname + window.location.search + window.location.hash;
                        window.location.href = "/sign/in?source=" + src;
                    }
                    return [4 /*yield*/, response.json()];
                case 1:
                    errMsg = _a.sent();
                    if (errMsg) {
                        throw new Error(errMsg);
                    }
                    throw new Error(response.statusText + " : " + response.status);
            }
        });
    }); })
        .then(function (response) { return response.json(); });
}
